import { render } from "./ResultForm.vue?vue&type=template&id=6be2fecd"
import script from "./ResultForm.vue?vue&type=script&lang=js"
export * from "./ResultForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/artur/code/vue/sirezi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__